import React from "react"; 
import classes from './Invoicedate.module.css';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import { useLocation } from 'react-router-dom';
import searchicon from "../../Assets/search.svg";
import filter from "../../Assets/Vector (1).png";
import { Eye, Edit, Trash } from "lucide-react";
import Footer from "../../Components/Footer/Footer";
import mail from "../../Assets/mail.png";
import call from "../../Assets/call.png";
import exportse from "../../Assets/file-download.png";
import alert from "../../Assets/alert-01.png";
import office from "../../Assets/office.png";

const Invoicedate = () => {
    const location = useLocation();

    const accountsData = [
        { InvoiceNumber: "INV-2024-001", Customer: "Acme corporation", Description: "Professional Services - January", Amount: "₦2,500,000.00", status: "Pending", Createdby: "John Kola", Lastmodified: "2024-01-15"  },
        { InvoiceNumber: "INV-2024-001", Customer: "Acme corporation", Description: "Professional Services - January", Amount: "₦2,500,000.00", status: "Active", Createdby: "John Kola", Lastmodified: "2024-01-15" },
        { InvoiceNumber: "INV-2024-001", Customer: "Acme corporation", Description: "Professional Services - January", Amount: "₦2,500,000.00", status: "Pending", Createdby: "John Kola", Lastmodified: "2024-01-15" },
        { InvoiceNumber: "INV-2024-001", Customer: "Acme corporation", Description: "Professional Services - January", Amount: "₦2,500,000.00", status: "Active", Createdby: "John Kola", Lastmodified: "2024-01-15" },
        { InvoiceNumber: "INV-2024-001", Customer: "Acme corporation", Description: "Professional Services - January", Amount: "₦2,500,000.00", status: "Active" , Createdby: "John Kola", Lastmodified: "2024-01-15" },
        { InvoiceNumber: "INV-2024-001", Customer: "Acme corporation", Description: "Professional Services - January", Amount: "₦2,500,000.00", status: "Pending" , Createdby: "John Kola", Lastmodified: "2024-01-15" },
        { InvoiceNumber: "INV-2024-001", Customer: "Acme corporation", Description: "Professional Services - January", Amount: "₦2,500,000.00", status: "Pending", Createdby: "John Kola", Lastmodified: "2024-01-15" },
        { InvoiceNumber: "INV-2024-001", Customer: "Acme corporation", Description: "Professional Services - January", Amount: "₦2,500,000.00", status: "Pending" , Createdby: "John Kola", Lastmodified: "2024-01-15" },
    ];

    const pageMap = {
        '/dashboard': 'Dashboard',
        '/transactions': 'Transactions',
        '/accounts': 'Accounting',
        '/reports': 'Reports',
        '/banking': 'Banking',
        '/settings': 'Settings',
    };

    return (
        <div>
            <HeaderNav activePage={pageMap[location.pathname]} />

            <div className={classes.Container}>
                <div className={classes.actions}>
                    <button className={classes.btns}>New Sales Invoice</button>
                    <button className={classes.btns}>New Purchase Invoice</button>
                    <button className={classes.btns}>All Invoices</button>
                    <button className={`${classes.btns} ${classes.greens}`}>Product & Services</button>
                </div>

                <header className={classes.Header}>
                    <h2 className={classes.Title}>Invoices without Date</h2>
                    <p className={classes.Titles}>
                        Invoices that are missing date information and require attention.
                    </p>
                </header>

                <div className={classes.headerActions}>
                    <div className={classes.actionsRight}>
                        <div className={classes.inputWrapper}>
                            <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
                            <input type="text" className={classes.searchBar} placeholder="Search invoices..." />
                        </div>

                        <div className={classes.selectWrapper}>
                            <select className={classes.dropdown}>
                                <option value="">All Status</option>
                                <option value="Paid">Paid</option>
                                <option value="Pending">Pending</option>
                                <option value="Overdue">Overdue</option>
                                <option value="Draft">Draft</option>
                            </select>
                            <span className={classes.dropdownArrow}>▼</span>
                        </div>

                        <div className={classes.inputWrapper}>
                            <input type="text" className={classes.searchBars} placeholder="Filter" />
                            <img src={filter} alt="Filter" className={classes.inputIcon} />
                        </div>
                    </div>

                    <div className={classes.btnsMain}>
                        <button className={classes.exportse}> <img src={exportse} alt="" className={classes.expo}/> Export</button>
                        <div className={classes.lastbtns}>
                            <button className={classes.alert}> <img src={alert} alt="" className={classes.aklerts}/> Invoice without Date</button>
                            <button className={classes.office}> <img src={office} alt="" className={classes.offices}/> List of Accounts</button>
                        </div>
                    </div>
                </div>

                <div className={classes.tableContaer}>
                    <table className={classes.table}>
                        <thead className={classes.tableHeader}>
                            <tr>
                                <th>Invoice Number</th>
                                <th>Customer</th>
                                <th>Description</th>
                                <th className={classes.amountColumn}>Amount</th>
                                <th>Status</th>
                                <th>Created By</th>
                                <th>Last Modified</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {accountsData.map((item, index) => ( 
                                <tr key={index} className={classes.tableRow}>
                                    <td className={classes.tableCell}>{item.InvoiceNumber}</td>
                                    <td className={classes.tableCell}>{item.Customer}</td>
                                    <td className={classes.tableCell}>{item.Description}</td>
                                    <td className={classes.tableCell} style={{ textAlign: 'right', paddingLeft: '30px', whiteSpace: 'nowrap' }}>
                                        {item.Amount}
                                    </td>
                                    <td className={classes.tableCell}>
                                        <span className={`${classes.statusButton} ${classes['status' + item.status]}`}>
                                            {item.status}
                                        </span>
                                    </td>
                                    <td className={classes.tableCell}>{item.Createdby}</td>
                                    <td className={classes.tableCell}>{item.Lastmodified}</td>
                                    <td className={`${classes.tableCell} ${classes.iconActions}`}>
                                        <Eye size={16} />
                                        <Edit size={16} style={{ margin: '0 8px' }} />
                                        <Trash size={16} />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <table className={classes.footerTable}>
                        <tfoot>
                            <tr>
                                <td className={classes.frston}>First</td>
                                <td className={`${classes.page} ${classes.activePage}`}>1</td>
                                <td className={classes.twono}>2</td>
                                <td className={classes.lastno}>Last</td>
                            </tr>
                        </tfoot>
                    </table>

                    <div className={classes.lasone}>
                        <div className={classes.paginationDisplay}>Displaying 1 - 41 of 41</div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Invoicedate;
